import { Profiler, ReactNode } from "react";
import { navPerf } from "@/lib/navPerf";

export const PerfProfiler = ({ id, children }: { id: string; children: ReactNode }) => {
  return (
    <Profiler
      id={id}
      onRender={(profilerId, phase, actualDuration, baseDuration, startTime, commitTime) => {
        navPerf.mark(`react-profiler:${profilerId}:${phase}`, {
          actualDuration,
          baseDuration,
          startTime,
          commitTime,
        });
      }}
    >
      {children}
    </Profiler>
  );
};
